import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import nofaroImg from "./images/nofaro.png";
import escolaE3Img from "./images/escolaE3.png";
import petLoveImg from "./images/petlove.png";
import ubookImg from "./images/ubook.jfif";
import beleafImg from "./images/beleaf.png";
import dominoPizzaImg from "./images/domino-s-pizza.jpg";
import goldKoImg from "./images/goldKo.png";
import luckauImg from "./images/luckau.jpg";
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';

const marketItens = [
    {
        Icon: LocalOfferOutlinedIcon,
        label: "Ofertas Fresquinhas",
        itens: [
            {
                img: escolaE3Img,
                title: "Escola E3",
                text: "25% de desconto em cursos para evolução do seu negócio"
            },
            {
                img: nofaroImg,
                title: "Nofaro",
                text: "15% de desconto em plano de saúde para o seu pet"
            },
            {
                img: petLoveImg,
                title: "Petlove",
                text: "10% de desconto em compras em todo site"
            },
            {
                img: ubookImg,
                title: "Ubook",
                text: "50% de descontos em livros, revistas e podcast nos 3 primeiros meses"
            }
        ]
    },
    {
        Icon: DeliveryDiningIcon,
        label: "Alimentção de Delivery",
        itens: [
            {
                img: beleafImg,
                title: "Beleaf",
                text: "20% de descontos em marmitas veganas!"
            },
            {
                img: dominoPizzaImg,
                title: "Domino's Pizza",
                text: "35% de descontos em pizzas"
            },
            {
                img: goldKoImg,
                title: "GoldKo",
                text: "15% de descontos em chocolates com sabor surreal!"
            },
            {
                img: luckauImg,
                title: "Luckau",
                text: "12% de descontos em chocolates zero açúcar"
            }
        ]
    },
    {
        Icon: ArrowForwardIosIcon,
        label: "Ofertas Fresquinhas",
        itens: [
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
        ]
    },
    {
        Icon: ArrowForwardIosIcon,
        label: "Ofertas Fresquinhas",
        itens: [
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
        ]
    },
    {
        Icon: ArrowForwardIosIcon,
        label: "Ofertas Fresquinhas",
        itens: [
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
            {
                img: nofaroImg,
                title: "Item generico",
                text: "Este é um texto generico com 25% de desconto."
            },
        ]
    },
]

export default marketItens